export * from './agris-cotizacion-detalle-page.component';
export * from './agris-insert-insum-cotiz-dialog';
export * from './agris-edit-price-ins-cotiz-dialog';
export * from './agris-cotiz-detalle-guardar-dialog';
export * from './agris-cotiz-detalle-pnjde-dialog';
export * from './agris-cotiz-detalle-renovar-dialog';
export * from './agris-coriz-perder-dialog';
export * from './agris-activity.pipe';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/index.ts